Ext.define('SA.view.ImportTermsWindow', {
    alias: 'widget.import-terms-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-import-terms-window',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-import-terms-window-body',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-import-terms-window-content',

                    html: [
                        '<h1>Importing Your Data into SimplyAnalytics</h1>',
                        '<h2>Terms of Service</h2>',
                        '<p class="sa-import-terms-window-intro-note">',
                            'By importing your data into SimplyAnalytics you agree to the following terms of service.',
                        '</p>',
                        '<h3>Your SimplyAnalytics Account</h3>',
                        '<p>',
                            'You are responsible for safeguarding your SimplyAnalytics login credentials. You are ',
                            'responsible for activity on your account, whether or not you authorized that activity. ',
                            'You should immediately notify us of any unauthorized use of your account.',
                        '</p>',
                        '<h3>Your Data</h3>',
                        '<p>',
                            'When importing data into SimplyAnalytics you provide us with tabular data (“your data”). ',
                            'You retain full ownership of your data.',
                        '</p>',
                        '<p>',
                            'You can remove your data by deleting it. However, in certain instances, some of your data ',
                            'may not be completely removed (when your data is shared with someone else, for example). ',
                            'We are not responsible or liable for the removal or deletion of any of your data, or the ',
                            'failure to remove or delete such data.',
                        '</p>',
                        '<p>',
                            'You are solely responsible for your data and indicate that you own or have the necessary ',
                            'rights to all of your data, and that use of your data does not infringe, misappropriate or ',
                            'violate a third party’s intellectual property rights, or rights of publicity or privacy, ',
                            'or result in the violation of any applicable law or regulation.',
                        '</p>',
                        '<p class="sa-import-terms-window-contact-us-note">',
                            'If you have any questions about these Terms, please contact us at ',
                            '<a href="mailto:support@simplyanalytics.com">support@simplyanalytics.com</a>.',
                        '</p>'
                    ]
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-import-terms-window-footer',

            items: [
                {
                    xtype: 'sa-button',
                    cls: 'sa-import-terms-window-agree-button',
                    itemId: 'agreeBtn',
                    text: 'I agree',
                    ui: 'primary'
                }, {
                    xtype: 'sa-button',
                    itemId: 'cancelBtn',
                    text: 'Cancel'
                }
            ]
        }
    ],

    initEvents() {
        this.callParent();

        this.down('#agreeBtn').on('click', () => this.fireEvent('click:agree'));
        this.down('#cancelBtn').on('click', () => this.fireEvent('click:cancel'));
    }
});